//   <script type="module">
    window.addEventListener('CORNER_COMPONENT_CLASSES_READY', (evt) => {
      const customElementsMap = new Map();
      class CornerCartLineItemExtended extends window.CORNER_COMPONENT_CLASSES.CornerCartLineItem {
        constructor() {
          super();
        }

  render() {
    if (!this.item) {
      return this.nothing;
    }
  
    try {
      return this.html`
        <div
          id="corner-cowi-cart-item-${this.index}"
          data-testid="corner-cart-line"
          data-corner-product-id=${this.item?.productId || ''}
          data-corner-variant-id=${this.item?.variantId || ''}
          data-product-type=${this.item?.productType || ''}
          data-vendor=${this.item?.vendor || ''}
          data-quantity=${this.item?.quantity || 0}
          class=${this.classMap({
            'corner-cowi-cart-item': true,
            hidden: !this.shouldShowAll,
          })}
          role="listitem"
          aria-label=${this.productTitle}
        >
          <div
            id=${`corner-cowi-cart-item-primary-info-${this.index}`}
            data-testid="corner-cowi-cart-item-primary-info"
            class="corner-cowi-cart-item-primary-info flex items-stretch"
          >
            <div
                id=${`corner-cowi-cart-item-list-item-image-${this.index}`}
                data-testid="corner-cowi-cart-item-list-item-image"
                class=${this.classMap({
                  'w-16': true,
                  'bg-cowi-card-bg': true,
                  relative: true,
                  'md:w-20': true,
                  flex: true,
                  'flex-wrap': true,
                  'items-start': true,
                  'flex-grow-0': true,
                  'flex-shrink-0': true,
                  'rounded-lg': true,
                  invisible: !this.shouldShowImage,
                  'pointer-events-none': !this.shouldShowImage,
                })}
                title=${this.imageLabel}
                @click=${this.handleImageClick}
              >
                ${this.renderImage()}
              </div>
            <div
              data-testid="corner-cowi-cart-item-list-item-info-body"
              id="corner-cowi-cart-item-list-item-info-body-${this.index}"
              class="corner-cowi-cart-item-list-item-info-body flex flex-col justify-between flex-grow ml-4"
            >
              <div
                data-testid="corner-cowi-cart-item-list-item-info-title-wrapper"
                id="corner-cowi-cart-item-list-item-info-title-wrapper-${this.index}"
                class="corner-cowi-cart-item-list-item-info-title-wrapper flex items-start"
              >
                <div class="grow">
                  ${this.renderTitle()}
                  ${this.renderVariantOptions()}
                  <div
                    id="corner-cowi-cart-item-line-properties-${this.index}"
                    class="corner-cowi-cart-item-line-properties text-xs flex flex-wrap leading-0 text-cowi-secondary-type"
                  >
                    ${this.renderSellingPlanBadge()}
                    ${this.renderRechargePlanBadge()}
                    ${this.renderOtherItemProperties()}
                  </div>
                </div>
                ${this.renderRemoveButton()}
              </div>
              ${this.renderLineItemMessages()}
              <div
                id="corner-cowi-cart-item-customiser-${this.index}"
                class=${this.classMap({
                  'corner-cowi-cart-item-customise': true,
                  flex: true,
                  'mt-3': true,
                  'items-center': true,
                  'justify-end': this.isQtyHidden,
                  'justify-between': !this.isQtyHidden,
                })}
              >
         ${this.when(this.item?.properties?._main_product_id, () => { return this.html`<div class="addon-quantity">${this.quantity}<div>`},
() => this.renderQtyControl()
)}
                ${this.renderPrice()}
              </div>
            </div>
          </div>
        </div>
      `;
    } catch (error) {
      console.error('Error rendering cart item:', error);
      return this.renderError();
    }
  }

      }

      customElementsMap.set('corner-cart-line-item', CornerCartLineItemExtended);
      window.CORNER_EXTENDED_CLASSES = customElementsMap;
    })
//   </script>